import i from "./index.es424.js";
function m() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.images, s = t === void 0 ? [] : t, a = e.sheetId;
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' + s.map(function(n, o) {
    return '<Relationship Id="rId'.concat(o + 1, '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="../media/').concat(i(n, {
      sheetId: a,
      sheetImages: s
    }), '"/>');
  }).join("") + "</Relationships>";
}
export {
  m as default
};
//# sourceMappingURL=index.es430.js.map
